"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _sortInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/sort");

var _indexOfInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/index-of");

var _context;

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var dictionary_1 = require("./dictionary");

function checkParenthesis(opening, closing, target, nextChar) {
  if (nextChar !== closing) {
    return false;
  }

  if (target.split(opening).length - target.split(closing).length === 1 || opening === closing && target.split(opening).length % 2 === 0) {
    return true;
  }
}

exports.checkParenthesis = checkParenthesis;
exports.maximumAttrLength = _sortInstanceProperty(_context = dictionary_1.htmlAttributes).call(_context, function (a, b) {
  return b.length - a.length;
})[0].length;

function isInsideAttribute(quoteType, prevFragment) {
  for (var index = 0; index < dictionary_1.htmlAttributes.length; index++) {
    var _context2, _context3;

    var atr = dictionary_1.htmlAttributes[index];
    var targetString = atr.toLowerCase() + "=" + quoteType;

    if (_indexOfInstanceProperty(_context2 = prevFragment.toLowerCase()).call(_context2, targetString) !== -1 && _indexOfInstanceProperty(_context3 = prevFragment.toLowerCase()).call(_context3, targetString) === prevFragment.length - targetString.length) {
      return true;
    }
  }

  return false;
}

exports.isInsideAttribute = isInsideAttribute;

function isInsideAnchorTag(target, fullInput, targetEnd) {
  var escapedTarget = target.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  var regex = new RegExp("(?=(<a))(?!([\\s\\S]*)(<\\/a>)(" + escapedTarget + "))[\\s\\S]*?(" + escapedTarget + ")(?!\"|')", "gi");
  var result = null;

  while ((result = regex.exec(fullInput)) !== null) {
    var end = result.index + result[0].length;

    if (end === targetEnd) {
      return true;
    }
  }

  return false;
}

exports.isInsideAnchorTag = isInsideAnchorTag;